module.exports = __webpack_public_path__ + "static/NP-Wire-Instructions-c36d68cd517430cdb6ec2aa01541ba50.pdf";